import { Link } from "react-router-dom";
import { ShieldCheck, Stars } from "lucide-react";

const HERO_IMG = "https://images.pexels.com/photos/8653950/pexels-photo-8653950.jpeg";
const ABOUT_IMG = "https://images.pexels.com/photos/7979768/pexels-photo-7979768.jpeg";

export default function Home() {
  return (
    <div className="bg-peach" data-testid="home-page">
      {/* HERO */}
      <section className="max-w-7xl mx-auto px-6 pt-12 pb-20 grid lg:grid-cols-2 gap-10 items-center">
        <div className="animate-fade-up">
          <span
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest"
            style={{ background: "#FFD708", color: "#13A699" }}
            data-testid="hero-tagline-badge"
          >
            <Stars className="h-4 w-4" /> Verified Coaches & Tutors
          </span>
          <h1
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-5 leading-[1.05]"
            style={{ color: "#13A699" }}
            data-testid="hero-heading"
          >
            Make Your Child<br />Skill Independent.
          </h1>
          <p className="mt-5 text-base sm:text-lg max-w-xl" style={{ color: "#13A699" }}>
            Discover trusted experts across academics, sports, arts, careers and more. Real mentors,
            real availability, real-time bookings.
          </p>
          <div className="mt-8 flex items-center gap-6 text-sm font-semibold" style={{ color: "#13A699" }}>
            <div className="flex items-center gap-2">
              <ShieldCheck className="h-5 w-5" /> Verified Profiles
            </div>
            <div className="flex items-center gap-2">
              <Stars className="h-5 w-5" /> Explorer Ratings
            </div>
          </div>
        </div>
        <div className="relative animate-fade-up">
          <div
            className="absolute -inset-4 rounded-[2rem] -z-0"
            style={{ background: "#FFD708", transform: "rotate(-2deg)" }}
          />
          <img
            src={HERO_IMG}
            alt="Tutor helping child"
            fetchpriority="high"
            decoding="async"
            className="relative rounded-[2rem] w-full h-[420px] object-cover shadow-xl"
            data-testid="hero-image"
          />
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <h2
          className="font-display text-3xl sm:text-4xl font-bold uppercase tracking-tight"
          style={{ color: "#13A699" }}
          data-testid="how-it-works-heading"
        >
          How It Works
        </h2>
        <div className="grid md:grid-cols-3 gap-6 mt-8">
          {[
            { n: "01", t: "Pick a Skill", d: "Browse the full vertical list of subjects and tick what your child wants to learn." },
            { n: "02", t: "Match Experts", d: "Onboarded mentors appear instantly with their bio, ratings and live availability." },
            { n: "03", t: "Book & Learn", d: "Pick a slot, see exact slots-left, and confirm. Rate the mentor after the session." },
          ].map((s) => (
            <div
              key={s.n}
              className="bg-white rounded-3xl p-6 border border-black/5 shadow-sm hover:-translate-y-1 transition-all duration-200"
              data-testid={`how-step-${s.n}`}
            >
              <div
                className="inline-flex items-center justify-center h-10 w-10 rounded-full font-bold"
                style={{ background: "#FFD708", color: "#13A699" }}
              >
                {s.n}
              </div>
              <h3 className="font-display text-xl font-bold mt-4" style={{ color: "#13A699" }}>
                {s.t}
              </h3>
              <p className="mt-2 text-sm" style={{ color: "#13A699" }}>{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CATEGORIES BAND */}
      <section className="max-w-7xl mx-auto px-6 py-12">
        <div className="rounded-[2rem] p-8 sm:p-12 grid md:grid-cols-2 gap-8 items-center" style={{ background: "#FFD708" }}>
          <div>
            <h2 className="font-display text-3xl sm:text-4xl font-bold uppercase" style={{ color: "#13A699" }}>
              Every Skill, One Place.
            </h2>
            <p className="mt-3 text-base sm:text-lg" style={{ color: "#13A699" }}>
              Career Skills · Activities · Sports · Development & Wellness · Hobbies · Academics
            </p>
            <Link
              to="/search"
              className="mt-6 btn-outline-teal inline-flex px-6 py-3"
              style={{ borderColor: "#13A699" }}
              data-testid="explore-subjects-btn"
            >
              Explore Subjects
            </Link>
          </div>
          <img src={ABOUT_IMG} alt="Mentor and pupil" loading="lazy" decoding="async" className="rounded-3xl w-full h-72 object-cover" />
        </div>
      </section>
    </div>
  );
}
